import React from "react";
import { Loader2 } from "lucide-react";

export function PrimaryButton({ children, loading, icon: Icon, className = "", ...props }) {
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      className={
        "inline-flex items-center justify-center gap-2 rounded-xl bg-mo-brand px-6 py-3.5 font-body text-sm font-extrabold uppercase tracking-wide text-mo-onbrand transition-all duration-200 hover:brightness-105 hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-60 disabled:hover:translate-y-0 " +
        className
      }
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : Icon ? <Icon className="h-4 w-4" /> : null}
      {children}
    </button>
  );
}

export function GhostButton({ children, icon: Icon, loading, className = "", ...props }) {
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      className={
        "inline-flex items-center justify-center gap-2 rounded-xl border border-mo-line bg-mo-surface2 px-5 py-3 font-body text-sm font-bold text-mo-ink transition-all duration-200 hover:border-mo-line2 hover:-translate-y-0.5 disabled:opacity-60 " +
        className
      }
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : Icon ? <Icon className="h-4 w-4" /> : null}
      {children}
    </button>
  );
}

export function SectionLabel({ children }) {
  return (
    <span className="font-body text-[11px] font-bold uppercase tracking-[0.22em] text-mo-brand">
      {children}
    </span>
  );
}

export function Field({ label, className = "", textarea, ...props }) {
  const base =
    "w-full rounded-xl border border-mo-line bg-white px-4 py-3 font-body text-[15px] text-black caret-black placeholder:text-neutral-500 outline-none transition-colors focus:border-mo-brand " +
    className;
  return (
    <label className="block">
      {label ? <span className="mb-1.5 block font-body text-xs font-bold text-mo-ink">{label}</span> : null}
      {textarea ? (
        <textarea {...props} className={base + " min-h-[96px] resize-y"} />
      ) : (
        <input {...props} className={base} />
      )}
    </label>
  );
}

export function Chip({ label, selected, onClick, className = "", ...props }) {
  return (
    <button
      type="button"
      onClick={onClick}
      {...props}
      className={
        "rounded-full border px-4 py-2 font-body text-[13px] font-semibold transition-all duration-200 " +
        (selected
          ? "border-mo-brand bg-mo-brand text-mo-onbrand"
          : "border-mo-line bg-mo-surface2 text-mo-ink hover:border-mo-line2") +
        " " + className
      }
    >
      {label}
    </button>
  );
}

export function Card({ children, className = "" }) {
  return (
    <div className={"rounded-2xl border border-mo-line bg-mo-card p-6 " + className}>{children}</div>
  );
}
